import { useEffect } from "react";

const HideInjectedElements = () => {
  useEffect(() => {
    // Function to hide the elements
    const hideElements = () => {
      const banner = document.querySelector(
        'div[style*="position: fixed; top: 16px; right: 16px;"]'
      );
      const overlay = document.querySelector(
        'div[style*="position: absolute; width: 100%; height: 100%; inset: 0px; opacity: 0.2; z-index: 101; pointer-events: none;"]'
      );

      if (banner) {
        banner.style.display = "none"; // Hide the first banner
      }

      if (overlay) {
        overlay.style.display = "none"; // Hide the second element (overlay)
      }

      return banner || overlay; // Return true if any element is found and hidden
    };

    // Check if elements exist at regular intervals
    const intervalId = setInterval(() => {
      const elementsHidden = hideElements();
      if (elementsHidden) {
        clearInterval(intervalId); // Stop checking once elements are hidden
      }
    }, 1); // Check every 100ms

    // Cleanup function to clear interval
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return null;
};

export default HideInjectedElements;
